if (!customElements.get('wlsn-accordion')) {
    class WLSNAccordion extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                openClass: 'open',
            };
            this.toggle = this.toggle.bind(this);
        }

        connectedCallback() {
            this.addEventListener('click', this.toggle);
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.toggle);
        }

        toggle() {
            this.classList.toggle(this.classes.openClass);
        }
    }

    customElements.define('wlsn-accordion', WLSNAccordion);
}
